import { atom } from 'recoil'

export const showCertLayerState = atom({
	key: "showCertLayerState",
	default: false
})

export const showCertListLayerState = atom({
	key: "showCertListLayerState",
	default: false
})

export const showCertImportLayerState = atom({
	key: "showCertImportLayerState",
	default: false
})

export const showChangePasswordLayerState = atom({
	key: "showChangePasswordLayerState",
	default: false
})